





















































































































































import { Component, Vue } from "vue-property-decorator";
import MoneyField2 from "@/components/MoneyField2.vue";
import * as util from "@/util";
import * as uiUtil from "@/uiUtil";
import { domain, User, TransactionType, Company, VueRoot, VueForm, Refund, BizumRefundResult } from "@/domain";
import { TransactionItem } from "@/domain/types/transactions_query";

@Component({ components: { MoneyField2 } })
export default class TxnEditDialog extends Vue {
  // New/Edit dialog
  dialog = false;
  editedItem: TransactionItem | null = null;
  opType: TransactionType | null = null;
  confirmKeyword = "";
  savingData = false;
  bizum = false;
  bizumRefunds = Array<Refund>();
  bizumLoading = true;

  // Edited data
  newOpCentsAmount = 0;
  newOpReference = "";
  newOpComment = "";
  confirmKeywordTyped = "";

  // Rules
  permissionError = false;

  get lang() {
    return this.$store.state.lang.data;
  }

  get langKey() {
    return this.$store.state.lang.key as string;
  }

  get referenceRules() {
    return [util.rules.required(this.lang.ruleInsertVaule), util.rules.length(this.lang.ruleMAx500, 1, 500)];
  }
  get amountRules() {
    if (!this.needsAmount) {
      return [];
    }
    return [
      util.rules.required(this.lang.ruleInsertVaule),
      (value: unknown) => util.toNumberSafe(value) > 0 || this.lang.ruleMinValue0
    ];
  }

  get needsAmount(): boolean {
    return this.opType === "sale" || this.opType === "refund" || this.opType === "authClose";
  }

  get originalAmountCents(): number {
    if (!this.editedItem || !this.editedItem.requestedAmount) {
      return 0;
    }
    return Math.round(Math.abs(util.toNumberSafe(this.editedItem.requestedAmount)) * 100);
  }

  get currentUser(): User {
    return this.$store.state.currentUser || {};
  }

  get currentCompany(): Company | null {
    if (this.$store.state.selectedCompanyLoading) {
      return null;
    }
    return this.$store.state.selectedCompany;
  }

  get isMobile(): boolean {
    return (this.$root as VueRoot).isMobile;
  }

  get isValid(): boolean {
    if (this.opType == "refund" || this.opType == "refundAC") {
      if (this.newOpCentsAmount > this.originalAmountCents) {
        return false;
      }
    }
    return !this.savingData && this.confirmKeywordTyped === this.confirmKeyword && this.validateEdit();
  }

  snackShow(message: string, color: string) {
    this.$emit("message", { message, color });
  }

  validateEdit(): boolean {
    if (!this.editedItem) {
      return false;
    }
    let valid = true;
    if (!(this.$refs.editForm as VueForm).validate()) {
      valid = false;
    }
    return valid;
  }

  async cmdSave() {
    if (!this.validateEdit()) {
      return;
    }
    if (
      !this.editedItem ||
      !this.currentCompany ||
      !this.editedItem.branchID ||
      !this.editedItem.commerceTCOD ||
      !this.editedItem.id ||
      !this.opType ||
      (this.needsAmount && this.newOpCentsAmount <= 0)
    ) {
      this.snackShow(this.lang.errorCheckForm, "error");
      return;
    }
    this.savingData = true;
    try {
      // aca
      const savedResult = await domain.backend.modifyTransaction({
        companyID: this.currentCompany.id,
        branchID: util.toNumber(this.editedItem.branchID),
        tcod: this.editedItem.commerceTCOD,
        previousTransactionID: util.toNumber(this.editedItem.id),
        type: this.opType,
        amountCents: this.needsAmount ? this.newOpCentsAmount : this.originalAmountCents,
        reference: this.newOpReference,
        comment: this.newOpComment,
        language: this.langKey
      });
      util.log("Transaction guardado", savedResult);
      this.snackShow(this.lang.alertEditedTransaction, "success");
      this.savingData = false;
      this.$emit("save", savedResult);
      this.close();
    } catch (error) {
      util.logError("Error modificando la transacción", error);
      this.savingData = false;
      this.snackShow(uiUtil.toErrorMsg(error, this.lang.errorCouldNotEditTransaction), "error");
    }
  }

  async cmdBizumSave() {
    if (!this.validateEdit()) {
      return;
    }
    if (
      !this.editedItem ||
      !this.currentCompany ||
      !this.editedItem.branchID ||
      !this.editedItem.commerceTCOD ||
      !this.editedItem.id ||
      !this.opType ||
      (this.needsAmount && this.newOpCentsAmount <= 0)
    ) {
      this.snackShow(this.lang.errorCheckForm, "error");
      return;
    }
    this.savingData = true;
    try {
      const savedResult = await domain.backend.bizumRefund({
        companyID: this.currentCompany.id,
        branchID: util.toNumber(this.editedItem.branchID),
        tcod: this.editedItem.commerceTCOD,
        previousTransactionID: util.toNumber(this.editedItem.id),
        type: this.opType,
        amountCents: this.needsAmount ? this.newOpCentsAmount : this.originalAmountCents,
        reference: this.newOpReference,
        comment: this.newOpComment,
        language: this.langKey
      });
      util.log("Transaction guardado", savedResult);
      if (savedResult.status === "ok") {
        this.snackShow(this.lang.alertEditedTransaction, "success");
      } else {
        this.snackShow(savedResult.message, "error");
      }
      this.savingData = false;
      this.close();
    } catch (error) {
      util.logError("Error modificando la transacción", error);
      this.savingData = false;
      this.snackShow(uiUtil.toErrorMsg(error, this.lang.errorCouldNotEditTransaction), "error");
    }
  }

  close() {
    this.dialog = false;
  }

  async getBizumRefundData() {
    this.bizumLoading = true;
    if (
      !this.editedItem ||
      !this.currentCompany ||
      !this.editedItem.branchID ||
      !this.editedItem.commerceTCOD ||
      !this.editedItem.id ||
      !this.opType
    ) {
      this.snackShow(this.lang.errorCheckForm, "error");
      return;
    }
    try {
      const savedResult = await domain.backend.bizumRefund({
        companyID: this.currentCompany.id,
        branchID: util.toNumber(this.editedItem.branchID),
        tcod: this.editedItem.commerceTCOD,
        previousTransactionID: util.toNumber(this.editedItem.id),
        type: this.opType,
        amountCents: 0,
        reference: "query",
        comment: this.newOpComment,
        language: this.langKey
      });
      this.bizumRefunds = savedResult.refunds;
      this.bizumLoading = false;
    } catch (e) {
      this.snackShow((e as BizumRefundResult).message, "error");
    }
  }

  // ------ PUBLIC Methods ------- //
  async openForEdit(item: TransactionItem, opType: TransactionType, confirmKeyword: string, bizum: boolean) {
    this.bizum = bizum;
    this.savingData = false;
    this.dialog = true;
    this.editedItem = item;
    this.opType = opType;
    this.confirmKeyword = confirmKeyword;
    this.confirmKeywordTyped = "";
    this.newOpReference = "";
    this.newOpComment = "";
    if (bizum) await this.getBizumRefundData();
    this.$nextTick(() => {
      this.newOpCentsAmount = this.opType === "refund" || this.opType === "authClose" ? this.originalAmountCents : 0;
      (this.$refs.editForm as VueForm).resetValidation();
    });
  }
  // ------ PUBLIC Methods ------- //
}
